import { render } from "./EmploymentStatusDropdown.vue?vue&type=template&id=a2662862"
import script from "./EmploymentStatusDropdown.vue?vue&type=script&lang=js"
export * from "./EmploymentStatusDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__